import 'leaflet/dist/leaflet.css';
import L, { LatLngExpression } from 'leaflet';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";

import { MapControls } from './MapControls/MapControls';
import pinIcon from './MapComponents/Icons/Pin.svg'
import UniversitySections from './MapComponents/UniversitySections/UniversitySections';

import { useResponsiveContext } from '../../../../contexts/ResponsiveContext';

type TProps = {
    borderRadius?: number | string;
    displaySections?: boolean;
    displayMarker?: boolean;
    markerPosition?: { lat: string | number, lng: string | number };
    draggableMarkerPosition?: { lat: number, lng: number };
    center?: { lat: string | number, lng: string | number };
    getLatLng?: (val: { lat: number, lng: number }) => void
    getSection?: (val: string | null) => void;
};

export const Map = ({ borderRadius, displaySections, draggableMarkerPosition, displayMarker, markerPosition, center, getLatLng, getSection }: TProps) => {
    const centerPos = center ? [center.lat, center.lng] : null;
    const [viewMode] = useResponsiveContext();

    const isMobile = viewMode === 'mobile';

    const markerIcon = new L.Icon({
        iconUrl: pinIcon,
        iconSize: [31, 35],
        iconAnchor: [15, 35]
    });

    return (
        <MapContainer
            zoom={17}
            minZoom={17}
            center={centerPos ? centerPos as LatLngExpression : [38.733, -9.1608703]}
            dragging={isMobile ? false : true}
            touchZoom={true}
            zoomControl={false}
            scrollWheelZoom={true}
            attributionControl={false}
            style={{ height: '100%', borderRadius: borderRadius ? borderRadius : '12px' }}
        >
            <ReactLeafletGoogleLayer type={'hybrid'} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} />
            {/* <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            /> */}
            {displaySections && <UniversitySections draggableMarkerPosition={draggableMarkerPosition} getLatLng={getLatLng} getSection={getSection} />}
            {displayMarker && markerPosition && <Marker position={markerPosition as LatLngExpression} icon={markerIcon} />}
            <MapControls />
        </MapContainer>
    );
};
